import React from 'react';

export const SelectArrow = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.8486 5.51562H4.15173C3.92087 5.51562 3.79196 5.75937 3.93493 5.92578L7.78337 10.3883C7.89353 10.516 8.10564 10.516 8.21696 10.3883L12.0654 5.92578C12.2084 5.75937 12.0795 5.51562 11.8486 5.51562Z"
                fill="#757575"
            />
        </svg>
    );
};
